import React, { useState, useEffect } from "react";
import { Laptop, MousePointer2, Copy, Check, Mail } from "lucide-react";
import "./MobileBlocker.css";
import iwmiLogo from "../../assets/logo/iwmi_white.svg";

const APP_URL = "https://waste-wise.org";

const MobileBlocker = ({ variant, onContinue }) => {
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    const prevHtml = document.documentElement.style.backgroundColor;
    const prevBody = document.body.style.backgroundColor;
    document.documentElement.style.backgroundColor = "#0D1441";
    document.body.style.backgroundColor = "#0D1441";
    return () => {
      document.documentElement.style.backgroundColor = prevHtml;
      document.body.style.backgroundColor = prevBody;
    };
  }, []);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(APP_URL);
    } catch {
      const el = document.createElement("input");
      el.value = APP_URL;
      document.body.appendChild(el);
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
    }
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const handleEmail = () => {
    const subject = encodeURIComponent("WasteWise link");
    const body = encodeURIComponent(
      `Hi,\n\nHere is the WasteWise link to open on your desktop or laptop:\n${APP_URL}\n`
    );
    window.location.href = `mailto:?subject=${subject}&body=${body}`;
  };

  return (
    <div className="mobileBlocker-root">
      <div className="mobileBlocker-card">
        <div className="mobileBlocker-icon">
          <div className="mobileBlocker-iconBox">
            <Laptop size={56} strokeWidth={1.6} />
            <MousePointer2 size={18} className="mobileBlocker-cursor" />
          </div>
        </div>

        <h1 className="mobileBlocker-title">WasteWise</h1>
        <p className="mobileBlocker-subtitle">MOBILE EXPERIENCE COMING SOON</p>

        <p className="mobileBlocker-body">
          WasteWise is designed for in-depth analysis on larger screens. For the complete decision
          support experience, please visit{" "}
          <a href={APP_URL} className="mobileBlocker-link" target="_blank" rel="noreferrer">
            {APP_URL}
          </a>{" "}
          on your desktop or laptop.
        </p>

        <div className="mobileBlocker-divider" />

        <div className="mobileBlocker-urlRow">
          <span className="mobileBlocker-urlText">{APP_URL}</span>
          <button className="mobileBlocker-copyBtn" onClick={handleCopy} aria-label="Copy link">
            {copied ? <Check size={16} /> : <Copy size={16} />}
            {copied ? "Copied" : "Copy"}
          </button>
        </div>

        <button className="mobileBlocker-emailBtn" onClick={handleEmail}>
          <Mail size={18} />
          Email link to my computer
        </button>

        {variant === "tablet" && onContinue && (
          <button className="mobileBlocker-continueBtn" onClick={onContinue}>
            Continue anyway
          </button>
        )}
      </div>

      <div className="mobileBlocker-footer">
        <span className="mobileBlocker-presented">PRESENTED BY</span>
        <div className="mobileBlocker-iwmi">
          <img src={iwmiLogo} alt="IWMI" className="mobileBlocker-iwmiLogo" />
        </div>
        <span className="mobileBlocker-copyright">
          © WasteWise • International Water Management Institute (IWMI)
        </span>
      </div>
    </div>
  );
};

export default MobileBlocker;
